(($, Drupal) => {
  const initCookieBanner = (el) => {
    const $document = $(el);

    const config = { attributes: true, childList: true, subtree: true };

    const initFocus = () => {
      const cookieWrapper = document.querySelector('#sliding-popup');
      const cookieModal = document.querySelector('.cookie-banner');
      const firstButton = cookieModal ? cookieModal.querySelector('.agree-button') : null;
      const mainContent = document.querySelector('.site-container'); // Huvudinnehållet

      if (cookieWrapper) {
        cookieWrapper.setAttribute('role', 'dialog');
        cookieWrapper.setAttribute('aria-modal', 'true');
      }

      if (cookieModal && firstButton) {
        // Göm allt annat från tabb-ordningen
        mainContent.setAttribute('tabindex', '-1');

        // Sätt fokus på första knappen i cookiemodalen
        firstButton.focus();

        // När användaren hanterat cookiemodalen, återställ tabbning
        firstButton.addEventListener('click', () => {
          mainContent.removeAttribute('tabindex');
        });
      }
    };

    const callback = (mutationList) => {
      mutationList.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-eu-cookie-compliance-once'
        ) {
          const $cookieBanner = $document.find('.cookie-banner');
          const $overlay = $document.find('.cookie-banner__overlay');
          const $cookiePrimary = $cookieBanner.find('.cookie-banner__primary');
          const $cookieSettings = $cookieBanner.find('.cookie-banner__categories');
          const $settingsToggler = $cookieBanner.find('.toggle-settings-button');
          const $closeButton = $cookieBanner.find('.eu-cookie-compliance-close-button');

          const toggleCookieSettings = () => {
            if ($cookieSettings.hasClass('open')) {
              $cookieSettings.removeClass('open');
              $cookiePrimary.removeClass('hidden');
              $cookieSettings.hide();
            } else {
              $cookieSettings.show();
              setTimeout(() => {
                $cookieSettings.addClass('open');
              }, 100);
              $cookiePrimary.addClass('hidden');
            }
          };

          const closeCookieBanner = () => {
            $('.sliding-popup-bottom').css({
              top: 'initial',
            });

            $('body').removeClass('eu-cookie-compliance-popup-open');
            $('.eu-cookie-compliance-banner, .eu-cookie-withdraw-banner')
              .attr('aria-hidden', true)
              .find('a, button, input')
              .attr('tabindex', -1);

            $overlay.hide();
          };

          $settingsToggler.on('click', toggleCookieSettings);
          $closeButton.on('click', closeCookieBanner);
          initFocus();
        }
      });
    };

    const observer = new MutationObserver(callback);

    observer.observe($(el).get(0), config);
  };

  Drupal.behaviors.mstCookieBanner = {
    attach: (context) => {
      initCookieBanner($(document), context);
    },
  };
})(jQuery, Drupal);
